import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, AccountDialogueHandler } from './types';
import AccountContext from './AccountContext';

const { ConfirmationDialogue } = vp;

type AccountDialogueProps = {
  handleAccountDialogue: DialogueHandler<AccountDialogueHandler>;
};

type FC = FunctionComponent<AccountDialogueProps>;

const AccountDialogue: FC = ({ handleAccountDialogue }: AccountDialogueProps) => {
  const {
    showDeleteAccountConfirmAlert,
    showDeleteAccountErrorAlert,
    showDeleteAccountSuccessAlert,
    deleteAccountError,
  } = useContext(AccountContext);

  return useMemo(
    () => (
      <div>
        {/* Account Delete Confirmation */}
        <ConfirmationDialogue
          isVisible={showDeleteAccountConfirmAlert}
          title="Are you sure you want to delete this transaction?"
          status="alert"
          subTitle="This action cannot be undone."
          confirm={{
            label: 'Yes',
            action: () => handleAccountDialogue({ type: 'confirm', state: 'confirm' }),
          }}
          cancel={{
            label: 'No',
            action: () => handleAccountDialogue({ type: 'confirm', state: 'fail' }),
          }}
        />
        {/* Delete Account Error */}
        <ConfirmationDialogue
          isVisible={showDeleteAccountErrorAlert}
          title="Error! The transaction was not deleted."
          status="error"
          subTitle={`${deleteAccountError}`}
          confirm={{
            label: 'Back',
            action: () => handleAccountDialogue({ type: 'delete', state: 'fail' }),
          }}
        />
        {/* Delete Account Success */}
        <ConfirmationDialogue
          isVisible={showDeleteAccountSuccessAlert}
          title="Success! The transaction was successfully deleted."
          status="success"
          subTitle="Navigate back to transaction."
          confirm={{
            label: 'Back to transaction',
            action: () => handleAccountDialogue({ type: 'delete', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showDeleteAccountConfirmAlert, showDeleteAccountErrorAlert, showDeleteAccountSuccessAlert, deleteAccountError],
  );
};

export default AccountDialogue;
